var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDigitalocean = function SvgDigitalocean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "digitalocean_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 603 103",
    style: {
      enableBackground: "new 0 0 603 103"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".digitalocean_svg__st0,.digitalocean_svg__st1{fill:#0080ff}.digitalocean_svg__st1{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_2369_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_2638_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_2639_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_49_",
    className: "digitalocean_svg__st0",
    d: "M52.1 102.1V82.5c20.8 0 36.8-20.6 28.9-42.4-3-8.1-9.4-14.6-17.5-17.5-21.8-7.9-42.4 8.1-42.4 28.9H1.5c0-33.1 32-58.9 66.7-48.1 15.2 4.7 27.2 16.8 31.9 31.9 10.8 34.8-14.9 66.8-48 66.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_47_",
    className: "digitalocean_svg__st1",
    d: "M52.1 82.5H32.6V63h19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_46_",
    className: "digitalocean_svg__st1",
    d: "M32.6 97.5h-15v-15h15v15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_45_",
    className: "digitalocean_svg__st1",
    d: "M17.6 82.5H5V70h12.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "digitalocean_svg__XMLID_2370_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2635_",
    className: "digitalocean_svg__st0",
    d: "M181.5 30.2c-5.8-4-13-6.1-21.4-6.1h-18.3v58.1h18.3c8.4 0 15.6-2.1 21.4-6.4 3.2-2.2 5.7-5.4 7.4-9.3 1.7-3.9 2.6-8.5 2.6-13.7 0-5.1-.9-9.7-2.6-13.6-1.7-3.8-4.2-6.9-7.4-9zm-29 3.8h5.8c6.4 0 11.7 1.3 15.7 3.7 4.4 2.7 6.7 7.8 6.7 15.1 0 7.6-2.3 12.9-6.7 15.8-3.8 2.5-9.1 3.8-15.6 3.8h-5.8V34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2634_",
    className: "digitalocean_svg__st0",
    d: "M204.3 23.4c-1.8 0-3.3.6-4.5 1.8-1.2 1.2-1.9 2.7-1.9 4.4 0 1.8.6 3.3 1.9 4.5 1.2 1.2 2.7 1.9 4.5 1.9 1.8 0 3.3-.6 4.5-1.9 1.2-1.2 1.9-2.8 1.9-4.5 0-1.8-.6-3.3-1.9-4.4-1.2-1.2-2.8-1.8-4.5-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2564_",
    className: "digitalocean_svg__st0",
    d: "M199 41.3h10.3v41H199z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2561_",
    className: "digitalocean_svg__st0",
    d: "M246.8 44.7c-3.1-2.8-6.6-4.4-10.3-4.4-5.7 0-10.4 2-14.1 5.8-3.7 3.8-5.5 8.8-5.5 14.7 0 5.8 1.8 10.7 5.5 14.7 3.7 3.8 8.4 5.8 14.1 5.8 4 0 7.4-1.1 10.2-3.3v1c0 3.4-.9 6-2.7 7.9-1.8 1.8-4.3 2.7-7.4 2.7-4.8 0-7.7-1.9-11.4-6.8l-7 6.7.2.3c1.5 2.1 3.8 4.2 6.9 6.2 3.1 2 6.9 3 11.5 3 6.1 0 11.1-1.9 14.7-5.6 3.7-3.7 5.5-8.7 5.5-14.9V41.3h-10.1v3.4zm-2.7 24.2c-1.8 2-4.1 3-7.1 3s-5.3-1-7-3c-1.8-2-2.7-4.7-2.7-8s.9-6.1 2.7-8.1c1.8-2 4.1-3.1 7-3.1 3 0 5.3 1 7.1 3.1 1.8 2 2.7 4.8 2.7 8.1s-1 6-2.7 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2560_",
    className: "digitalocean_svg__st0",
    d: "M265.7 41.3H276v41h-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2552_",
    className: "digitalocean_svg__st0",
    d: "M271 23.4c-1.8 0-3.3.6-4.5 1.8-1.2 1.2-1.9 2.7-1.9 4.4 0 1.8.6 3.3 1.9 4.5 1.2 1.2 2.7 1.9 4.5 1.9 1.8 0 3.3-.6 4.5-1.9 1.2-1.2 1.9-2.8 1.9-4.5 0-1.8-.6-3.3-1.9-4.4-1.2-1.2-2.8-1.8-4.5-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2509_",
    className: "digitalocean_svg__st0",
    d: "M298.6 30.3h-10.1v11.1h-5.9v9.4h5.9v17c0 5.3 1.1 9.1 3.2 11.3 2.1 2.2 5.8 3.3 11.1 3.3 1.7 0 3.4-.1 5-.2h.5v-9.4l-3.5.2c-2.5 0-4.1-.4-4.9-1.3-.8-.9-1.2-2.7-1.2-5.4V50.7h9.6v-9.4h-9.6v-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2508_",
    className: "digitalocean_svg__st0",
    d: "M356.5 24.1h10.3v58.1h-10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2470_",
    className: "digitalocean_svg__st0",
    d: "M470.9 67.6c-1.8 2.1-3.7 3.9-5.2 4.8-1.4.9-3.2 1.4-5.3 1.4-3 0-5.5-1.1-7.5-3.4s-3-5.2-3-8.7 1-6.4 2.9-8.6c2-2.3 4.4-3.4 7.4-3.4 3.3 0 6.8 2.1 9.8 5.6l6.8-6.5c-4.4-5.8-10.1-8.5-16.9-8.5-5.7 0-10.6 2.1-14.6 6.1-4 4-6 9.2-6 15.3s2 11.2 6 15.3c4 4.1 8.9 6.1 14.6 6.1 7.5 0 13.5-3.2 17.5-9.1l-6.5-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2460_",
    className: "digitalocean_svg__st0",
    d: "M513.2 47c-1.5-2-3.5-3.7-5.9-4.9-2.5-1.2-5.3-1.8-8.5-1.8-5.8 0-10.5 2.1-14 6.3-3.4 4.2-5.2 9.3-5.2 15.4 0 6.2 1.9 11.3 5.7 15.3 3.7 3.9 8.8 5.9 14.9 5.9 6.9 0 12.7-2.8 16.9-8.4l.2-.3-6.7-6.5c-.6.8-1.5 1.6-2.3 2.4-1 1-2 1.7-3 2.2-1.5.8-3.3 1.1-5.2 1.1-2.9 0-5.2-.8-7-2.5-1.7-1.5-2.7-3.6-2.9-6.2h27.3l.1-3.8c0-2.7-.4-5.2-1.1-7.6-.7-2.3-1.8-4.5-3.3-6.6zm-22.5 9.7c.5-2 1.4-3.6 2.7-4.9 1.4-1.4 3.2-2.1 5.4-2.1 2.5 0 4.4.7 5.7 2.1 1.2 1.3 1.9 2.9 2.1 4.8h-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2456_",
    className: "digitalocean_svg__st0",
    d: "M552.8 44.4c-3.1-2.7-7.4-4-12.8-4-3.4 0-6.6.8-9.5 2.2-2.7 1.4-5.3 3.6-7 6.6l.1.1 6.6 6.3c2.7-4.3 5.7-5.8 9.7-5.8 2.2 0 3.9.6 5.3 1.7s2 2.6 2 4.4v2c-2.6-.8-5.1-1.2-7.6-1.2-5.1 0-9.3 1.2-12.4 3.6-3.1 2.4-4.7 5.9-4.7 10.2 0 3.8 1.3 7 4 9.3 2.7 2.2 6 3.4 9.9 3.4 3.9 0 7.6-1.6 10.9-4.3v3.4h10.1V55.9c.2-4.9-1.4-8.8-4.6-11.5zm-18.3 22.2c1.2-.8 2.8-1.2 4.9-1.2 2.5 0 5.1.5 7.8 1.5v4C545 73 542 74 538.3 74c-1.8 0-3.2-.4-4.1-1.2-.9-.8-1.4-1.7-1.4-3s.6-2.4 1.7-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2454_",
    className: "digitalocean_svg__st0",
    d: "M597.2 45.2c-2.9-3.2-6.9-4.8-12-4.8-4.1 0-7.4 1.2-9.9 3.5v-2.5h-10.1v41h10.3V59.7c0-3.1.7-5.6 2.2-7.3 1.5-1.8 3.4-2.6 6.1-2.6 2.3 0 4.1.8 5.4 2.3 1.3 1.6 2 3.7 2 6.4v23.7h10.3V58.5c0-5.6-1.4-10.1-4.3-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2450_",
    className: "digitalocean_svg__st0",
    d: "M343.6 44.4c-3.1-2.7-7.4-4-12.8-4-3.4 0-6.6.8-9.5 2.2-2.7 1.4-5.3 3.6-7 6.6l.1.1 6.6 6.3c2.7-4.3 5.7-5.8 9.7-5.8 2.2 0 3.9.6 5.3 1.7s2 2.6 2 4.4v2c-2.6-.8-5.1-1.2-7.6-1.2-5.1 0-9.3 1.2-12.4 3.6-3.1 2.4-4.7 5.9-4.7 10.2 0 3.8 1.3 7 4 9.3 2.7 2.2 6 3.4 9.9 3.4 3.9 0 7.6-1.6 10.9-4.3v3.4h10.1V55.9c.1-4.9-1.5-8.8-4.6-11.5zm-18.3 22.2c1.2-.8 2.8-1.2 4.9-1.2 2.5 0 5.1.5 7.8 1.5v4c-2.2 2.1-5.2 3.1-8.9 3.1-1.8 0-3.2-.4-4.1-1.2-.9-.8-1.4-1.7-1.4-3s.5-2.4 1.7-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "digitalocean_svg__XMLID_2371_",
    className: "digitalocean_svg__st0",
    d: "M404.2 83.1c-16.5 0-30-13.4-30-30s13.4-30 30-30c16.5 0 30 13.4 30 30s-13.5 30-30 30zm0-49.3c-10.7 0-19.4 8.7-19.4 19.4s8.7 19.4 19.4 19.4 19.4-8.7 19.4-19.4-8.7-19.4-19.4-19.4z"
  })))));
};

export default SvgDigitalocean;